import AfterPayment from './after-payment';

export default AfterPayment;